import type { ImagingStudyModel } from 'generated/types';

import { FhirResource } from './fhir-resource';

export type ImagingStudyValues = Pick<
  ImagingStudyRecord,
  'orthancStudyId' | 'studyName'
>;

export class ImagingStudyRecord extends FhirResource {
  protected model: ImagingStudyModel;

  public constructor(model: ImagingStudyModel) {
    super(model);
    this.model = model;
  }

  public get studyName() {
    return this.model.description;
  }

  public get orthancStudyId() {
    return this.model.identifier?.find((i) => i?.system === 'urn:orthanc:id')
      ?.value;
  }

  public get dicomViewerToken() {
    return this.model.dicom_viewer_token;
  }

  public getModelInput() {
    return FhirResource.getCleanInput(this.model);
  }
}
